export default __webpack_public_path__ + "dist/media/Section 2.530e4feb.png";